import { AlertTriangle } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type ServiceChangesWarningModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export function ServiceChangesWarningModal({
  open,
  onOpenChange,
  onConfirm,
}: ServiceChangesWarningModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-ds-amber-500" />
            Reclasificare necesară
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-ds-text-600">
            Ați modificat serviciile selectate. Clasificarea NIS2 va fi
            recalculată, iar datele completate în secțiunea de{" "}
            <span className="font-semibold">Analiză de Impact</span> vor fi
            pierdute.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Anulează</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
          >
            Continuă și recalculează
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
